// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Footer from "examples/Footer";
import Switch from "@mui/material/Switch";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import iconClientes from "assets/images/icons/icono_clientes.ico";
import iconUsuarios from "assets/images/icons/icono_usuario.ico";
import iconErp from "assets/images/icons/icono_erp.ico";
import iconDB from "assets/images/icons/icono_db.ico";
import iconAlerta from "assets/images/icons/icono_alerta.ico";
import ClientesSiesa from "./componentes/dashboard/clientes-siesa";
import ClientesErp from "./componentes/dashboard/clientes-erp";
import ClientesSbs from "./componentes/dashboard/clientes-sbs";
import Clientes85 from "./componentes/dashboard/clientes-85";
import Usuarios from "./componentes/dashboard/usuarios-conectados";
import CargaEc2 from "./componentes/ec2/cargaCpuRamEc2";
import CargaRds from "./componentes/rds/cargaCpuLoadRds";
import AlertaEc2 from "./componentes/dashboard/alertaEC2";
import AlertaRds from "./componentes/dashboard/alertaRDS";
import BackupCreator from "./componentes/dashboard/backupCreator";
import TabWindow from "./componentes/dashboard/ventanaPrueba";
import { Box, Typography } from "@mui/material";
import { Margin } from "@mui/icons-material";

function Dashboard() {
  const descVision =
    "Ser una plataforma de apalacamiento a los procesos de la operacion Siesa, para ser mas proativos, poder planear mejor el hacer de nuestros clientes y el tiempo de estar bien sea menor.";
  const descMision =
    "Desarrollar herramientas para conocer el estado de los artefactos que apoyan los productos Siesa en el cliente, para conocerlo mejor en busca de un mundo de posibilidades de mejora.";
  const descCaracteristicas =
    "Agnostica, Monitoreo y Control, Proactividad, Segregacion de permisos, Loggeable";
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <MDBox
            p={0}
            ml={1}
            mr={-2}
            sx={{
              border: "0px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "transparent",
              mb: 4,
              width: "100%",
            }}
          >
            <MDBox mb={4} ml={2}>
              <Typography variant="h5" fontWeight="bold">
                Clientes ERP
              </Typography>
            </MDBox>
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <ClientesSiesa />
              <ClientesErp />
              <ClientesSbs />
              <Clientes85 />
              <Usuarios />
            </Grid>
          </MDBox>
          <MDBox
            p={0}
            ml={1}
            mr={-2}
            sx={{
              border: "0px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "transparent",
              mb: 5,
              width: "100%",
            }}
          >
            <MDBox mb={4} ml={2}>
              <Typography variant="h5" fontWeight="bold">
                Carga EC2
              </Typography>
            </MDBox>
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <CargaEc2 />
            </Grid>
          </MDBox>
          <MDBox
            p={0}
            ml={1}
            mr={-2}
            sx={{
              border: "0px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "transparent",
              mb: 4,
              width: "100%",
            }}
          >
            <MDBox mb={4} ml={2}>
              <Typography variant="h5" fontWeight="bold">
                Carga RDS
              </Typography>
            </MDBox>
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <CargaRds />
            </Grid>
          </MDBox>
          <MDBox
            p={0}
            ml={1}
            mr={-2}
            sx={{
              border: "0px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "transparent",
              mb: 4,
              width: "100%",
            }}
          >
            <MDBox mb={4} ml={2}>
              <Typography variant="h5" fontWeight="bold">
                Alertas
              </Typography>
            </MDBox>
            <Grid container spacing={3} direction="row" justifyContent="flex-start">
              <AlertaEc2 />
              <AlertaRds />
            </Grid>
          </MDBox>
        </Grid>
      </MDBox>
      {/* vision y mision resumen de la plataforma */}
      <MDBox py={2} ml={-2} mr={-1}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={4} py={1}>
            <Card>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Visión
                </MDTypography>
              </MDBox>
              <MDBox pt={1} pb={3} px={3}>
                <MDBox component="form" role="form">
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    {descVision}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Misión
                </MDTypography>
              </MDBox>
              <MDBox pt={1} pb={3} px={3}>
                <MDBox component="form" role="form">
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    {descMision}
                  </MDTypography>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Card>
              <MDBox
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                  Caraterísticas
                </MDTypography>
              </MDBox>
              <MDBox pt={1} pb={2} px={2} lineHeight={1.25}>
                <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  <MDBox mt={0.5}>
                    <Switch checked={true} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Agnostica
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  <MDBox mt={0.5}>
                    <Switch checked={true} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Monitoreo y Control
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  <MDBox mt={0.5}>
                    <Switch checked={true} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Proactividad
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  <MDBox mt={0.5}>
                    <Switch checked={true} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Segregacion de permisos
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <MDBox display="flex" alignItems="center" mb={0.5} ml={-1.5}>
                  <MDBox mt={0.5}>
                    <Switch checked={true} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Loggeable
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
